//import "./safetyforms.css";
import { useContext, useEffect, useState } from "react";
import "react-dropdown/style.css";
import { FaArrowLeft, FaFolderPlus, FaRegFilePdf, FaSearch, FaSpinner, FaTimesCircle, FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { fetchDocumentsByFolder, selectDocuments, selectDocumentsByFolder, selectLoading } from "../common/slices/document";
import { deleteFolder, fetchFolders, selectFolderOpen, selectFoldersByParentId, toggleFolder } from "../common/slices/folder";
import { ButtonBase } from "./Buttons";
import { DocumentList, Folder } from "./DocumentList";
import ModalNewFolder from "./ModalNewFolder";
import ModalUploadDocument from "./ModalUploadDocument";
import Row from "./Row";
import { StyledSearch } from "./Search";
import Sidebar from "./Sidebar";
import { Tab, TabContainer, TabContext } from "./Tabs";
import { H1 } from "./Typography";
import Divider from "./Divider";
import { pathNames } from "../constants";
import ListHeader from "./ListHeader";
import { toast } from "react-toastify";
import ModalConfirm from './ModalConfirm';
import { ErrorContext } from "../ErrorContext";


const FolderItem = ({ folder, onDocumentClick, onFolderClick }) => {
    const dispatch = useDispatch();
    const expanded = useSelector(state => selectFolderOpen(state, folder.id));
    return (
        <>
            <Folder expanded={expanded} title={folder.name} onClick={() => { onFolderClick(folder); dispatch(toggleFolder(folder.id)) }} />
            {expanded && <div style={{ paddingLeft: '1rem' }}><FolderList folderId={folder.id} onDocumentClick={onDocumentClick} onFolderClick={onFolderClick} /></div>}
        </>
    )
}


const FolderList = ({ folderId, onDocumentClick, onFolderClick }) => {
    const errorContext = useContext(ErrorContext);
    const dispatch = useDispatch();
    const folders = useSelector(selectFoldersByParentId(folderId));
    const documents = useSelector(selectDocumentsByFolder(folderId));

    useEffect(() => {
        (async () => {
            try {
                await dispatch(fetchDocumentsByFolder(folderId));
                await dispatch(fetchFolders(folderId));
            } catch (ex) {
                errorContext.setError({ errorMessage: "Failed to get folder list.", forSupport: ex.message });
            }
        })()
    }, [folderId, dispatch])

    return (
        <div style={{ border: '0px solid #d9d9d9' }}>
            {folders?.map(folder => <FolderItem key={folder.id} folder={folder} onDocumentClick={onDocumentClick} onFolderClick={onFolderClick} />)}
            <DocumentList documents={documents} onClick={onDocumentClick} />
        </div>
    )
}

const SidebarDocumentList = ({ onDocumentClick, search }) => {
    const nav = useNavigate();
    const dispatch = useDispatch();
    const [showConfirm, setShowConfirm] = useState(false);
    const [showSearch, setShowSearch] = useState(!!search);
    const [showUpload, setShowUpload] = useState(false);
    const [showNewFolder, setShowNewFolder] = useState(false);
    const rootFolders = useSelector(selectFoldersByParentId("root"));
    const documents = useSelector(selectDocuments);
    const loading = useSelector(selectLoading);
    const [activeFolder, setActiveFolder] = useState(null);

    const onSearch = (data) => {
        nav(`${pathNames.SAFETYFORMS}/manage?search=${data.search}`)
    }

    const onDeleteFolder = async () => {
        const success = await dispatch(deleteFolder(activeFolder));
        if (success) toast.success("Folder deleted");
        setShowConfirm(false);
    }

    return (
        <Sidebar>
            <Row>
                <ButtonBase onClick={() => nav(pathNames.SAFETYFORMS)} style={{ paddingLeft: 0, alignSelf: "flex-start" }}>
                    <FaArrowLeft size={"16px"} color="#000" />
                </ButtonBase>
                <H1>Safety Forms</H1>
            </Row>
            {showSearch === false && (
                <Row>
                    <ButtonBase style={{ padding: "0.5rem" }} onClick={() => setShowSearch(true)}>
                        <FaSearch size={"14px"} color="#000" />
                    </ButtonBase>
                    <Divider.Vertical />
                    <ButtonBase style={{ padding: "0.5rem" }} onClick={() => setShowUpload(true)}>
                        <FaRegFilePdf size={"14px"} color="#000" />
                    </ButtonBase>
                    <ButtonBase style={{ padding: "0.5rem" }} onClick={() => setShowNewFolder(true)}>
                        <FaFolderPlus size={"14px"} color="#000" />
                    </ButtonBase>
                    {
                        activeFolder &&
                        <ButtonBase style={{ padding: "0.5rem" }} onClick={() => setShowConfirm(true)}>
                            <FaTrash size={"14px"} color="#000" />
                        </ButtonBase>
                    }
                    {loading && <FaSpinner className="fa-spin" />}
                </Row>
            )}

            {
                showSearch === false &&
                <TabContainer initialTab={rootFolders?.[0]?.id}>
                    <Row>
                        {rootFolders?.map(folder => <Tab key={folder.id} tabId={folder.id} onClick={() => setActiveFolder(folder.id)}>{folder.name}</Tab>)}
                    </Row>

                    <ListHeader>Documents</ListHeader>

                    <TabContext.Consumer>
                        {(ctx) => <FolderList folderId={ctx.active} onDocumentClick={onDocumentClick} onFolderClick={({ id }) => setActiveFolder(id)} />}
                    </TabContext.Consumer>

                    <TabContext.Consumer>
                        {ctx => (<>
                            {showUpload && <ModalUploadDocument folderId={activeFolder || ctx.active} onClose={() => setShowUpload(false)} />}
                            {showNewFolder && <ModalNewFolder parent={{ id: activeFolder || ctx.active }} onClose={() => setShowNewFolder(false)} />}
                        </>)}
                    </TabContext.Consumer>
                </TabContainer>
            }


            {showSearch === true && (
                <StyledSearch search={search} onSubmit={onSearch} onResetClick={() => {
                    nav(`${pathNames.SAFETYFORMS}/manage`);
                    setShowSearch(false)
                }} containerStyle={{ flex: 0 }} />
            )}
            {showSearch === true && (
                <div>
                    <DocumentList documents={documents} onClick={onDocumentClick} />
                </div>
            )}
            {showConfirm && <ModalConfirm
                title="Delete Folder"
                description="Are you sure you want to delete this folder?  Any documents inside will also be deleted!"
                onClose={() => setShowConfirm(false)}
                onConfirm={onDeleteFolder}
            />}
        </Sidebar>
    )
}

export default SidebarDocumentList;